import * as React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import PromoBanner from '../components/PromoBanner';

const NotFound: React.FC = () => {
  const [roast, setRoast] = React.useState<string>('');
  
  // Funny 404 roasts
  const roasts = [
    "This page has been roasted so hard it no longer exists",
    "404: Page not found. Even our AI couldn't find anything worth roasting here",
    "Looks like this URL is selling thin air. 0 stars, would not recommend",
    "This page is like a bad Amazon listing - it promised a lot but delivered nothing",
    "We've analyzed this URL and found 404 problems with it",
    "Even our brutal AI reviewer refuses to roast this non-existent page",
    "Our AI tried to roast this page but couldn't find it. That's the ultimate burn",
    "404: This page has worse visibility than a 10th page Amazon listing",
    "This URL has the worst conversion rate we've ever seen: 0%",
    "Sorry, this page has been delisted due to poor performance"
  ];
  
  React.useEffect(() => {
    // Set a random roast on load
    const randomRoast = roasts[Math.floor(Math.random() * roasts.length)];
    setRoast(randomRoast);
  }, []);
  
  return (
    <HelmetProvider>
      <div>
        <Helmet>
          <title>404 - Page Not Found | RoastMyListing.ai</title>
        </Helmet>
        
        <PromoBanner />
        
        <div style={{ 
          backgroundColor: '#1f2937',
          padding: '0px 20px',
          margin: '0',
          textAlign: 'center',
          minHeight: '70vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          color: 'white'
        }}>
          <img 
            src="/logo.png" 
            alt="RoastMyListing.ai Logo" 
            style={{ 
              width: '500px', 
              height: 'auto',
              margin: '0 auto 30px',
              display: 'block'
            }} 
          />
          
          <h1 style={{ 
            fontSize: '120px', 
            margin: '0 0 20px',
            color: '#f97316',
            fontWeight: '800'
          }}>
            404
          </h1>
          
          <h2 style={{ 
            fontSize: '28px', 
            marginBottom: '30px',
            fontWeight: 'bold',
            color: 'white'
          }}>
            {roast}
          </h2>
          
          <p style={{ marginBottom: '30px', color: '#d1d5db', maxWidth: '600px', margin: '0 auto 30px' }}>
            This page has vanished faster than poor-quality listings from Amazon's first page.
          </p>
          
          <Link 
            to="/" 
            style={{
              backgroundColor: '#f97316',
              color: 'white',
              padding: '10px 20px',
              textDecoration: 'none',
              fontWeight: 'bold',
              borderRadius: '4px',
              display: 'inline-block',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              boxShadow: '0 4px 8px rgba(249, 115, 22, 0.3)',
              transition: 'all 0.3s ease',
              fontSize: '14px',
              width: '180px',
              margin: '0 auto'
            }}
          >
            BACK TO HOMEPAGE
          </Link>
        </div>
      </div>
    </HelmetProvider>
  );
};

export default NotFound;
